// App.js
import { useState } from 'react';
import './App.css';

function App() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    title: '',
    email: ''
  });
  const [copied, setCopied] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const generateSignature = () => {
    return `<div style="color-scheme: light dark;">
    <table style="width: 100%; max-width: 520px; background-color: #ffffff !important; color: #000000 !important; padding: 20px; border-spacing: 0; font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif; border-radius: 12px; border: 1px solid #f0f0f0;">
        <tr>
            <td style="padding: 0;">
                <!-- Header Section -->
                <table style="width: 100%; border-spacing: 0;">
                    <tr>
                        <!-- Logo Column -->
                        <td style="padding: 0; vertical-align: middle; width: 40px;">
                            <img src="https://cdn.prod.website-files.com/63d557706aee26630737c9be/677f89b02c4178d35f6fad09_Imgur%20Image.png" width="32" style="max-width: 100%; height: auto;" alt="Kunso Logo">
                        </td>
                        <!-- Name and Title Column -->
                        <td style="padding: 0 0 0 12px; vertical-align: middle;">
                            <table style="border-spacing: 0;">
                                <tr>
                                    <td style="padding: 0;">
                                        <span style="color: #0A3B3B !important; font-size: 18px; font-weight: 600; letter-spacing: -0.01em; display: inline-block;">${formData.firstName} ${formData.lastName}</span>
                                        <span style="color: #1f6c5d !important; font-size: 14px; margin-left: 12px; font-weight: 450;">${formData.title}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <!-- Social Links -->
                        <td style="padding: 0; text-align: right; vertical-align: middle;">
                            <a href="https://www.linkedin.com/company/kunso/" target="_blank" style="text-decoration: none;">
                                <img src="https://cdn.prod.website-files.com/63d557706aee26630737c9be/677f89ca37901496566eae60_Email%20-%20Linkedin%20.png" width="20" style="max-width: 100%; height: auto;" alt="LinkedIn">
                            </a>
                        </td>
                    </tr>
                </table>

                <!-- Separator -->
                <div style="height: 1px; background: linear-gradient(to right, #40B0A3, #E5E9E9); margin: 12px 0;"></div>

                <!-- Contact Information -->
                <table style="width: 100%; border-spacing: 0;">
                    <tr>
                        <td style="padding: 2px 24px 2px 0;">
                            <a href="mailto:${formData.email}@kunso.com" style="color: #535B5B !important; font-size: 13px; text-decoration: none; display: inline-flex; align-items: center;">
                                <span style="font-weight: 600; color: #1f6c5d !important; margin-right: 6px;">M.</span>
                                ${formData.email}@kunso.com
                            </a>
                        </td>
                        <td style="padding: 2px 0;">
                            <a href="https://kunso.com" target="_blank" style="color: #535B5B !important; font-size: 13px; text-decoration: none; display: inline-flex; align-items: center;">
                                <span style="font-weight: 600; color: #1f6c5d !important; margin-right: 6px;">W.</span>
                                kunso.com
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding: 2px 24px 2px 0;">
                            <span style="color: #535B5B !important; font-size: 13px; display: inline-flex; align-items: center;">
                                <span style="font-weight: 600; color: #1f6c5d !important; margin-right: 6px;">P.</span>
                                +65 8921 2160
                            </span>
                        </td>
                        <td style="padding: 2px 0;">
                            <span style="color: #535B5B !important; font-size: 13px; display: inline-flex; align-items: center;">
                                <span style="font-weight: 600; color: #1f6c5d !important; margin-right: 6px;">A.</span>
                                12, Arumugam Road, LTC, Singapore 409958
                            </span>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</div>`;
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(generateSignature());
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="container">
      <h1>Kunso Email Signature Generator</h1>

      <div className="form">
        <div className="form-row">
          <div className="form-group">
            <label>First Name</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="First Name"
            />
          </div>
          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Last Name"
            />
          </div>
        </div>

        <div className="form-group">
          <label>Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Your Title"
          />
        </div>

        <div className="form-group">
          <label>Email</label>
          <div className="email-input">
            <input
              type="text"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your.email"
            />
            <span className="email-domain">@kunso.com</span>
          </div>
        </div>
      </div>

      <button
        onClick={copyToClipboard}
        className={copied ? 'copy-button copied' : 'copy-button'}
      >
        {copied ? 'Copied!' : 'Copy Signature'}
      </button>

      <div className="preview">
        <h2>Preview:</h2>
        <div dangerouslySetInnerHTML={{ __html: generateSignature() }} />
      </div>
    </div>
  );
}

export default App;